import { GET_CORPORATES, GET_SOURCE_ACCOUNTS } from "../types/corporateType";

const initialState = {
    corporates: [],
    sourceAccounts: []
};

const corporateReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_CORPORATES:
            return {
                ...state,
                corporates: payload
            };
        case GET_SOURCE_ACCOUNTS:
            return {
                ...state,
                sourceAccounts: payload
            };
        default:
            return state;
    }
};

export default corporateReducer;
